import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { HomeService } from '../../../../services/home.service';
import { TranslateService } from '../../../../services/translate.service';
import { Observable } from 'rxjs/internal/Observable';
import { EmployeesService } from '../../../../services/employees';
import { FinancialManagerService } from '../../../../services/financial-manager';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { UserInterface } from '../../../../interfaces/user-interface';

@Component({
  selector: 'app-dailyexpensespage',
  templateUrl: './dailyexpensespage.component.html',
  styleUrl: './dailyexpensespage.component.scss'
})
export class DailyexpensespageComponent {
  selectedYear!: number;
  selectedMonth!: string;
  month!: string; // الناتج النهائي بصيغة YYYY-MM
  years: number[] = [];
  months = [
    { name: 'يناير', name_en: 'January', value: '01' },
    { name: 'فبراير', name_en: 'February', value: '02' },
    { name: 'مارس', name_en: 'March', value: '03' },
    { name: 'أبريل', name_en: 'April', value: '04' },
    { name: 'مايو', name_en: 'May', value: '05' },
    { name: 'يونيو', name_en: 'June', value: '06' },
    { name: 'يوليو', name_en: 'July', value: '07' },
    { name: 'أغسطس', name_en: 'August', value: '08' },
    { name: 'سبتمبر', name_en: 'September', value: '09' },
    { name: 'أكتوبر', name_en: 'October', value: '10' },
    { name: 'نوفمبر', name_en: 'November', value: '11' },
    { name: 'ديسمبر', name_en: 'December', value: '12' }
  ];

  userData!: users;
  data!: any;
  id!: any;

  contentReady: boolean = true;
  uniqueDates: string[] = [];
  filteredDate: string = '';
  allRecords: any[] = [];
  expenses: any[] = [];
  Revenues: any[] = [];
  expenseTotal!: any;
  revenueTotal!: any;
  filteredRecords: any;
  filteredMonth: any;
  originalRevenues: any[] = [];
  originalExpenses: any[] = [];
  isAr: boolean = localStorage.getItem("language") == "ar";
  uniqueMonths: string[] = [];
  showFinPopUp: boolean = false;
  amount!: any;
  note!: any;
  finId!: any;
  noteSearch: string = '';
  accountType!: string;
  isAdmin!: boolean;
  isMobile!: boolean;
  isSubAdmin!: boolean;
  totalAmount: number = 0;
  day: any;
  allUsers: UserInterface[] = [];
    searchKey: string = '';
  constructor(
    private _FinancialManager: FinancialManagerService,
    private _userService: UserService,
    private _homeService: HomeService,
  ) {
    const today = new Date();
    this.selectedYear = today.getFullYear();
    this.selectedMonth = (today.getMonth() + 1).toString().padStart(2, '0');
    this.updateMonth();
    for (let y = 2015; y <= 2030; y++) {
      this.years.push(y);
    }
  }

  ngOnInit() {
    this.contentReady = false;

this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
       
      },
      error: (error) => console.error(error),
    });
    this.getAllUsers();
    // Set default date to today
    this.month = new Date().toISOString().slice(0, 7); // "2025-07"
    this.getByMonth()
  }
search() {
    if (this.searchKey.trim() === '') return;
    
    this._FinancialManager.searchBalances(this.searchKey).subscribe({
      next: (res) => {

       this.Revenues = res["imbalances"];
       this.expenses = res["outbalances"];
      },
      error: (err) => {
        console.error('Search Error:', err);
      }
    });
  }
  onMonthYearChange() {
    this.updateMonth();
  }
  getByMonth() {
    this.contentReady = true;
    this._FinancialManager.getInbalanceByMonth(`${this.selectedYear}-${this.selectedMonth}`).subscribe(res => {
      this.Revenues = res;
      this.calculateTotal();
    });
    this._FinancialManager.getOutbalanceByMonth(`${this.selectedYear}-${this.selectedMonth}`).subscribe(res => {
      this.expenses = res;
      this.calculateTotal();
    });


  }

  getByDate() {
    this.contentReady = true;
    this._FinancialManager.getInbalanceByDate(this.day).subscribe(res => {

      this.Revenues = res;
      this.calculateTotal();
    });
    this._FinancialManager.getOutbalanceByDate(this.day).subscribe(res => {
      this.expenses = res;
      this.calculateTotal();
    });


  }
  updateMonth() {
    this.month = `${this.selectedYear}-${this.selectedMonth}`;
    console.log('الشهر المختار:', this.month);
  }

  calculateTotal() {
    const revenueTotal = this.Revenues.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    const expenseTotal = this.expenses.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    this.expenseTotal = expenseTotal;
    this.revenueTotal = revenueTotal;
    this.contentReady = false;
  }


  addExpenses() {
    this.showFinPopUp = true;
    this.finId = 1;
  }
  addRevenues() {
    this.showFinPopUp = true;
    this.finId = 2;
  }
  close() {
    this.finId = null
    this.showFinPopUp = false;
  }
  onSubmit() {
    var username = localStorage.getItem("username")
    this.contentReady = true;
    const bonusPayload = {
      employee_id: this.id,
      username: username,
      amount: this.amount,
      note: this.note
    };
    if (this.finId == 1) {
      this._FinancialManager.addexpenses(bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getByMonth()
          this.close()
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تمام" : 'success',
            text: this.isAr ? "تم اضافة المصروف" : 'expenses added',
          });
          this.day = null;
        },
        error: (error) => console.error(error),
      });

    }
    else {
      this._FinancialManager.addRevenue(bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تمام" : 'success',
            text: this.isAr ? "تم اضافة الربح" : 'revenue added',
          });
          this.getByMonth()
          this.close()
          this.day = null;
        },
        error: (error) => console.error(error),
      });

    }


  }
  delete(type: any, id: any) {
    var username = localStorage.getItem("username")
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        if (type == 1) {
          this._FinancialManager.deleteRev(id, username!).subscribe({
            next: (res) => {
              this.contentReady = false;
              this.getByMonth()
            },
            error: (err) => console.log(err),
          });
        }
        else {
          this._FinancialManager.deleteEx(id, username!).subscribe({
            next: (res) => {
              this.contentReady = false;
              this.getByMonth()
            },
            error: (err) => console.log(err),
          });
        }

      }
    });

  }
edit(type: any, id: any) {
  this.contentReady = true;

  const newAmount = prompt('اكتب المبلغ الجديد:');
  if (!newAmount || isNaN(Number(newAmount))) {
    alert('من فضلك أدخل رقم صحيح');
    this.contentReady = false;
    return;
  }

  const newNote = prompt('أدخل الملاحظة (اختياري):') || '';

  this._FinancialManager.editAmount(id, Number(newAmount), type, newNote).subscribe({
    next: (res) => {
      console.log('Updated:', res);
      alert(res.message);
      this.contentReady = false;
       this.getByMonth()
    },
    error: (err) => {
      console.error('Error updating amount:', err);
      alert('حدث خطأ أثناء التعديل');
      this.contentReady = false;
    },
  });
}


   
  
  translateTypeEnum(type: any): string {
    switch (String(type)) {
      case "0":
        return this.isAr ? 'عمولة' : 'commission';
      case "1":
        return this.isAr ? 'راتب' : 'Salary';
      case "2":
        return this.isAr ? 'سلفه' : 'Loan';
      case "3":
        return this.isAr ? 'اوردر' : 'Order';
      case "4":
        return this.isAr ? 'توريد' : 'supply';
      default:
        return this.isAr ? '' : '';
    }

  }
  getAllUsers() {
    this.contentReady = true;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {

        this.allUsers = data.filter((user: any) => user.type == 1 || user.type == 6);
        console.log(this.allUsers);
        this.contentReady = false;

      },
      error: (error) => console.error(error),
    });
  }
  userFilter(id: any) {
    var month = `${this.selectedYear}-${this.selectedMonth}`;
    var day = this.day;

    this._FinancialManager.getEmployeeBalances(id, month, day).subscribe(res => {

      this.expenses = res.outbalances;
      this.Revenues = res.inbalances;
      this.calculateTotal();

    });

  }
       formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }
  getArchivedBalances() {
    this._FinancialManager.getArchivedBalances().subscribe({
      next: (data) => {
        this.Revenues = data.archived_imbalances;
        this.expenses = data.archived_outbalances;
        console.log(this.expenses);
        this.calculateTotal();
      },
      error: (err) => {
        console.error('Error loading archived balances:', err);
      }
    });
  }
}
